{
  "title": "Changelog",
  "description": "Gérez les entrées du changelog public visible par les praticiens et institutions.",
  "addEntry": "Nouvelle entrée",
  "table": {
    "version": "Version",
    "date": "Date",
    "titleFr": "Titre (FR)",
    "status": "Statut",
    "actions": "Actions",
    "published": "Publié",
    "draft": "Brouillon",
    "empty": "Aucune entrée de changelog."
  },
  "form": {
    "createTitle": "Nouvelle entrée de changelog",
    "createDescription": "Créer une nouvelle entrée de version pour le changelog public.",
    "editTitle": "Modifier l'entrée de changelog",
    "editDescription": "Mettre à jour une entrée de changelog existante.",
    "version": "Version",
    "releaseDate": "Date de publication",
    "isPublished": "Publié",
    "title": "Titre",
    "titlePlaceholder": "Quoi de neuf dans cette version...",
    "highlights": "Points forts",
    "improvements": "Améliorations",
    "fixes": "Corrections",
    "add": "Ajouter",
    "remove": "Supprimer",
    "highlightIcon": "Icône",
    "highlightTitle": "Titre",
    "highlightDescription": "Description",
    "improvementPlaceholder": "Décrivez l'amélioration...",
    "fixPlaceholder": "Décrivez la correction...",
    "french": "Français",
    "english": "Anglais",
    "cancel": "Annuler",
    "create": "Créer",
    "save": "Enregistrer"
  },
  "delete": {
    "title": "Supprimer l'entrée de changelog",
    "description": "Êtes-vous sûr de vouloir supprimer l'entrée pour la version {{version}} ? Cette action est irréversible.",
    "cancel": "Annuler",
    "confirm": "Supprimer"
  },
  "success": {
    "created": "Entrée de changelog créée avec succès",
    "updated": "Entrée de changelog mise à jour avec succès"
  },
  "errors": {
    "fetchFailed": "Échec du chargement des entrées de changelog",
    "createFailed": "Échec de la création de l'entrée de changelog",
    "updateFailed": "Échec de la mise à jour de l'entrée de changelog",
    "deleteFailed": "Échec de la suppression de l'entrée de changelog"
  }
}
